import React from 'react';
import { useViewportHeight } from '../../hooks/useViewportHeight';
import style from './GameInfoLoader.scss';

const GameInfoLoader = ({ isVisible = false }) => {
    useViewportHeight();

    return (
        <div className={`${style.gameInfoLoader} ${isVisible ? style.show : style.hide}`}>
            <div className={`${style.swissIcon}`} />
        </div>
    );
};

export default GameInfoLoader;
